import React, { FC, useState, useEffect } from 'react'
import styles from 'styles/components/template.module.scss'
import { FirebaseDocRefType } from 'firebase'
import { State } from 'index'
import { push } from 'connected-react-router'
import { useDispatch, useSelector } from 'react-redux'
import { BlueButton, GreyButton } from 'components/Button'
import { PointCardCodeList } from 'components/List'
import { MainHeadline } from 'components/Typography'
import { Spacer } from 'components/Utility'
import { getPointCard } from 'reducks/pointCard/selectors'
import { PointCardCodeType as BasicPointCardCodeType } from 'types/pointCard/pointCardCode'
import { fetchPointCardCodes } from 'repos/pointCard/pointCardCode'

type PointCardCodeType = BasicPointCardCodeType & { ref: FirebaseDocRefType }

const PointCardCodeListTemplate: FC = () => {
  const dispatch = useDispatch()
  const pointCard = useSelector((state: State) => getPointCard(state))

  const [pointCardCodes, setPointCardCodes] = useState<PointCardCodeType[]>([])

  useEffect(() => {
    ;(async () => {
      if (!pointCard) return
      const pointCardId = pointCard.ref.id
      const pointCardCodes = await fetchPointCardCodes(pointCardId)
      setPointCardCodes([...pointCardCodes.filter((pointCardCode) => !pointCardCode.is_in_store)])
    })()
  }, [pointCard])

  return (
    <div className={styles.standard}>
      <Spacer size={40} />
      <MainHeadline headline={'発行済のQRコード'} />
      <PointCardCodeList pointCardCodes={pointCardCodes} />
      <Spacer size={12} />
      <BlueButton
        label={'QRコードを作成する'}
        onClick={() => dispatch(push('/point_card/code/create'))}
        size={'medium'}
        type={'main'}
      />
      <Spacer size={40} />
      <GreyButton
        label={'ポイント付与QRコード'}
        onClick={() => dispatch(push('/point_card/code'))}
        size={'medium'}
        type={'outlined'}
      />
      <Spacer size={40} />
    </div>
  )
}

export default PointCardCodeListTemplate
